<template>
    <div class="flex gap-1 items-center min-w-0">
        <resource-link v-if="link" :urn="link" class="truncate min-w-0">
            {{ link.display }}
        </resource-link>
        <UDropdownMenu v-if="numberOfLinks > 1" :items="resourceLinkMenuItems" class="shrink-0">
            <UBadge
                variant="subtle"
                size="sm"
                :label="`+ ${ numberOfLinks - 1 }`"
            />
            <template #item="{ item }">
                <resource-link :urn="item.urn">
                    {{ item.label }}
                </resource-link>
            </template>
        </UDropdownMenu>
    </div>
</template>

<script setup lang="ts">
import {ICellRendererParams} from 'ag-grid-community'
import ResourceLink from '@/resource-link/ResourceLink.vue'
import {Assignment} from '@/assignments/Assignment.type'
import {computed} from 'vue'
import {DropdownMenuItem} from '@nuxt/ui'

const props = defineProps({
    params: {
        type: Object as () => ICellRendererParams<Assignment>,
        required: true
    }
})

const link = computed(() => {
    return props.params.data?.resourceLinks?.[0]
})

const numberOfLinks = computed(() => {
    return props.params.data?.resourceLinks?.length ?? 0
})

const resourceLinkMenuItems = computed<DropdownMenuItem[]>(() => {
    const items: DropdownMenuItem[] = []
    if (props.params.data?.resourceLinks) {
        props.params.data.resourceLinks.map((rl, index) => {
            if (index != 0) {
                items.push({
                    label: rl.display,
                    urn: rl
                })
            }
        })
    }
    return items
})
</script>

<style scoped>

</style>